import { Tooltip } from "@kyan/ui";

import { InstrumentTag } from "#/components/InstrumentTag/InstrumentTag";
import { useMarketIndexPrice } from "#/store/app/indexPrices/marketIndexPrice";
import { type UnderlyingSymbol } from "#/types/markets";
import { createPerpInstrumentName } from "#/utils/instrument.utils";

export interface PerpWithCancelProps {
  disabled?: boolean;
  className?: string;
  underlying: string;
  onRemove?: () => void;
}

export const PerpWithCancel: React.FC<PerpWithCancelProps> = ({
  disabled = false,
  className,
  underlying,
  onRemove,
}) => {
  const { marketIndexPrice } = useMarketIndexPrice();

  return (
    <Tooltip
      side="bottom"
      disabled={!disabled}
      content={
        <div className="text-center">
          RFQ supports Options only,
          <br />
          Perp cannot be included
          <br />
          in a combo trade.
        </div>
      }
    >
      <div>
        <InstrumentTag
          disabled={disabled}
          className={className}
          price={marketIndexPrice}
          instrumentName={createPerpInstrumentName(
            underlying as UnderlyingSymbol,
          )}
          onRemove={onRemove}
        />
      </div>
    </Tooltip>
  );
};
